import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class PasswordResetInit {

    constructor(private http: Http) {}

    save(mail: string): Observable<any> {
        return this.http.post('api/v5/account/reset_password/init', mail);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/password-reset/init/password-reset-init.service.ts